import api from "@/services/api";
import { DashboardDateRangeParams } from "@/interfaces/DashboardDossierStats";
import {
  DashboardMeetingStatsResponse,
  DashboardMeetingDetailsParams,
  DashboardMeetingDetailsResponse,
} from "@/interfaces/DashboardMeetingStats";

export const dashboardMeetingStatsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getDashboardMeetingDetails: build.query<
      DashboardMeetingDetailsResponse,
      DashboardMeetingDetailsParams
    >({
      query: (params) => ({ url: "/admin/stats/meetings/details", params }),
      providesTags: [
        { type: "DashboardStats", id: "MEETINGS" },
        { type: "Meetings", id: "LIST" },
        { type: "CompanyMeetings", id: "LIST" },
        { type: "MontageMeetings", id: "LIST" },
        "CompanyUsers",
        "Users",
        { type: "CallLogs", id: "LIST" },
      ],
    }),
    getDashboardMeetingStats: build.query<
      DashboardMeetingStatsResponse,
      DashboardDateRangeParams
    >({
      query: (params) => ({ url: "/admin/stats/meetings", params }),
      providesTags: [{ type: "DashboardStats", id: "MEETINGS" }],
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetDashboardMeetingStatsQuery,
  useGetDashboardMeetingDetailsQuery,
} = dashboardMeetingStatsApi;
